// import { useEffect } from 'react';

const useScript = url => {
    window.loadedScripts = window.loadedScripts || [];
    if (window.loadedScripts[url]) {
        return new Promise(function (resolve) {
            resolve();
        });
    }

    return new Promise(function (resolve, reject) {
        let script = document.createElement("script");
        script.src = url;
        script.type = "text/javascript";
    
        window.loadedScripts[url] = true;
    
        script.onload = function () {
            resolve(url);
        };
    
        script.onerror = function () {
            console.log(url + " load failed");
            reject(url);
        }
    
        document["body"].appendChild(script);
    });
};

export default useScript;